import * as  firebase from 'firebase'

const config = {
    // apiKey: "AIzaSyAui7himZVjcFMz5WwkRhlog_AC1G-xKLc",
    // authDomain: "eaten-9a975.firebaseapp.com",
    // databaseURL: "https://eaten-9a975.firebaseio.com",
    // projectId: "eaten-9a975",
    // storageBucket: "eaten-9a975.appspot.com",
    // messagingSenderId: "129573697398",
    // appId: "1:129573697398:web:888344d58a86c241f7ac57",
    // measurementId: "G-0WPD7VJQDH"
    apiKey: "AIzaSyC93aEvClx7qxNkcY0qqaUgInucht4PkK4",
    authDomain: "the-tconcept.firebaseapp.com",
    databaseURL: "https://the-tconcept.firebaseio.com",
    projectId: "the-tconcept",
    storageBucket: "the-tconcept.appspot.com",
    messagingSenderId: "209348301454",
    appId: "1:209348301454:web:8a3d3a820e02920dd06fdf",
    measurementId: "G-E0ZB7ZB53T"
}

firebase.initializeApp(config)

export default firebase 

